import { Box, Stack, Typography } from '@mui/material'
import { GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { UploadVisualsTypes, useClientPropertySelfUploadPopup } from './ClientPropertySelfUploadPopup.context'

import { DynamicFlowStep } from 'components/common/DynamicFlow'
import { FC } from 'react'
import { MUICheckCard } from 'components/common/MUICards'
import { UploadVisualsStepKey } from './ClientPropertySelfUploadPopup.controller'
import { useTranslation } from 'react-i18next'

export const UploadOptionsStep: FC = () => {
  const { t } = useTranslation(['self_upload_popup'])

  const { uploadVisualsType, setUploadVisualsType } = useClientPropertySelfUploadPopup()

  return (
    <DynamicFlowStep
      stepKey={UploadVisualsStepKey.OPTIONS}
      isValid={true}
    >
      <Stack alignItems="center" gap={3} padding="3.2rem 0">

        {Object.values(UploadVisualsTypes).map((key) => (
          <Box width="100%" key={key}>
            <MUICheckCard
              key={key}
              isRadio
              isHeaderClickable
              checked={uploadVisualsType === key}
              onCheck={() => setUploadVisualsType(key)}
            >
              <Typography variant='text-md' fontWeight={600} color={GRAY_900}>
                {t(`upload_visuals_type.${key}.title`)}
              </Typography>
              <Typography variant='text-md' fontWeight={400} color={GRAY_700}>
                {t(`upload_visuals_type.${key}.description`)}
              </Typography>
            </MUICheckCard>
          </Box>
        ))}

      </Stack>
    </DynamicFlowStep>
  )
}
